import PropTypes from "prop-types"
import Results from "modules/securities-finder-results"
import Facets from "modules/securities-finder-facets"
import { DATE, DROPDOWN_OPTION } from "helpers/shapes"
import SecuritiesSearchParameters from "modules/securities-search-parameters"

function SecuritiesFinder(props) {
  return (
    <div className="modules_securities-finder">
      <SecuritiesSearchParameters
        filter={props.filter}
        updateFilters={props.updateFilters}
        setFilter={props.setFilter}
        portfoliosList={props.portfoliosList}
        watchlistsList={props.watchlistsList}
        swapsList={props.swapsList}
        etfsList={props.etfsList}
        indexesList={props.indexesList}
        startDate={props.startDate}
        endDate={props.endDate}
        selectedDate={props.selectedDate}
        unmodeledDates={props.unmodeledDates}
        setDate={props.setDate}
        heapAddFilterId="screener-filter-add"
        account={props.account}
        modelId={props.modelId}
        noDateSelection={props.noDateSelection}
        allowFiltersToggle={props.allowFiltersToggle}
        context={props.context}
        instrumentPortfolio={props.instrumentPortfolio}
        currency={props.currency}
        isHistoricalFactorSensitivityAvailable={props.isHistoricalFactorSensitivityAvailable}
      />
      <div className="results">
        <Facets
          selectedDate={props.selectedDate}
          modelId={props.modelId}
          currency={props.currency}
          filter={props.filter}
          filterId={props.filterId}
          toggleFacet={props.toggleFacet}
          toggleClassificationFacets={props.toggleClassificationFacets}
          selectedCountries={props.selectedCountries}
          selectedCurrencies={props.selectedCurrencies}
          selectedClassifications={props.selectedClassifications}
        />
        <Results
          selectedDate={props.selectedDate}
          modelId={props.modelId}
          currency={props.currency}
          isHistoricalFactorSensitivityAvailable={props.isHistoricalFactorSensitivityAvailable}
          filter={props.facetedFilter}
          filterId={props.facetedFilterId}
          setSort={props.setSort}
          selectedSort={props.sort}
          setPage={props.setPage}
          page={props.page}
          selectedColumns={props.selectedColumns}
          setSelectedColumns={props.setSelectedColumns}
        />
      </div>
    </div>
  )
}

SecuritiesFinder.propTypes = {
  selectedDate: DATE.isRequired,
  modelId: PropTypes.string.isRequired,
  portfoliosList: PropTypes.arrayOf(DROPDOWN_OPTION),
  watchlistsList: PropTypes.arrayOf(DROPDOWN_OPTION),
  etfsList: PropTypes.arrayOf(DROPDOWN_OPTION),
  swapsList: PropTypes.arrayOf(DROPDOWN_OPTION),
  indexesList: PropTypes.arrayOf(DROPDOWN_OPTION),
  unmodeledDates: PropTypes.objectOf(PropTypes.bool),
  filter: PropTypes.object,
  filterId: PropTypes.string,
  setFilter: PropTypes.func.isRequired,
  facetedFilter: PropTypes.object,
  facetedFilterId: PropTypes.string,
  allowFiltersToggle: PropTypes.bool,
  endDate: DATE,
  startDate: DATE,
  setDate: PropTypes.func,
  setSort: PropTypes.func.isRequired,
  sort: PropTypes.object,
  setPage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  account: PropTypes.string.isRequired,
  noDateSelection: PropTypes.bool,
  context: PropTypes.string,
  instrumentPortfolio: PropTypes.object,
  currency: PropTypes.string,
  isHistoricalFactorSensitivityAvailable: PropTypes.bool,
  selectedCountries: PropTypes.object,
  selectedCurrencies: PropTypes.object,
  selectedClassifications: PropTypes.object,
  toggleFacet: PropTypes.func.isRequired,
  toggleClassificationFacets: PropTypes.func.isRequired,
  setSelectedColumns: PropTypes.func.isRequired,
  selectedColumns: PropTypes.objectOf(PropTypes.bool).isRequired,
  updateFilters: PropTypes.func.isRequired,
}

export default SecuritiesFinder
